<template>
  <v-col 
    :cols="cols"
    :xs="xs"
    :sm="sm"
    :md="md"
    :lg="lg"
    :xl="xl"
    :order="order" 
    class="ma-0"
    :class="computedSpacing"
  >
    <slot />
  </v-col>
</template>

<script>
export default {
  name: 'AppCol',

  props: {
    cols: {
      type: [Boolean, String, Number],
      required: false,
    },
    xs: {
      type: [Boolean, String, Number],
      required: false,
    },
    sm: {
      type: [Boolean, String, Number],
      required: false,
    },
    md: {
      type: [Boolean, String, Number],
      required: false,
    },
    lg: {
      type: [Boolean, String, Number],
      required: false,
    },
    xl: {
      type: [Boolean, String, Number],
      required: false,
    },
    order: {
      type: [String, Number],
      required: false,
    },
    containsInputFields: {
      type: Boolean,
      default: false,
    },
    hasInputFieldsAbove: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedSpacing() {
      const output = {
        'app-col': true,
        'app-col--no-input-fields-inside': !this.containsInputFields,
        'pb-0': this.containsInputFields,
        'app-col--no-input-fields-above': !this.hasInputFieldsAbove,
        'pt-0': this.hasInputFieldsAbove
      }
      
      return output
    }
  }
}
</script>

<style scoped>
.app-col {
  padding-left: 10px;
  padding-right: 10px;
}

.app-col--no-input-fields-inside {
  padding-bottom: 10px;
}

.app-col--no-input-fields-above {
  padding-top: 10px;
}
</style>